import { Task, TaskStatus } from '@/services/types/client-intake-types';
import { CanonicalTaskGroup } from '@/services/types/task-types';

/**
 * Filters task statuses based on the task's group.
 * For Police Report & Investigation tasks, only specific statuses are allowed.
 */
export const filterTaskStatusesByGroup = (
  statuses: TaskStatus[],
  task?: Task | null,
): TaskStatus[] => {
  if (!task) return statuses;

  const isPoliceReportTask =
    task.group?.canonical_group ===
    CanonicalTaskGroup.POLICE_REPORT_INVESTIGATION;

  if (!isPoliceReportTask) return statuses;

  // For police report tasks, only allow these statuses
  const allowedStatusNames = [
    'Pending',
    'Complete',
    'Blocked',
    'In Progress',
    'Not Applicable',
  ];

  return statuses.filter((status) => allowedStatusNames.includes(status.name));
};
